import { texteEnLangue, type Langue } from '@artosera/shared';
import type { ExpositionPresentee } from '../../api/expositions.js';
import {
  bornesDepuisJours,
  estJour,
  minutesDeLHeure,
  type EvenementCalendrier,
} from '../../composants/calendrier/periodes.js';
import { teinteDeLEtat } from './etatUi.js';

/**
 * Les dates d'une exposition sont des jours civils posés à minuit UTC (comme
 * l'agenda de l'API, `dateVersDateCivile`) : on lit le jour dans l'ISO, sans
 * le glisser par le fuseau.
 */
function jourDe(iso: string): string | null {
  const jour = iso.slice(0, 10);
  return estJour(jour) ? jour : null;
}

/**
 * Une exposition en événements de calendrier : une barre du premier au
 * dernier jour (la teinte dit l'état), et son vernissage à l'heure, mis en
 * évidence. Une exposition aux dates illisibles n'en donne aucun.
 */
export function evenementsDeLExposition(
  exposition: ExpositionPresentee,
  options: {
    langue: Langue;
    galerieSlug: string;
    titreVernissage: (titre: string) => string;
  },
): EvenementCalendrier[] {
  const debut = jourDe(exposition.debutLe);
  const fin = jourDe(exposition.finLe);
  if (!debut) return [];
  const titre = texteEnLangue(exposition.titre, options.langue);
  const href = `/${options.galerieSlug}/expositions/${exposition.id}`;
  const evenements: EvenementCalendrier[] = [
    {
      id: `${exposition.id}:periode`,
      titre,
      ...bornesDepuisJours(debut, fin),
      teinte: teinteDeLEtat(exposition.etat),
      href,
    },
  ];
  const vernissage = exposition.vernissage;
  const jourVernissage = vernissage ? jourDe(vernissage.date) : null;
  const minuteDebut = vernissage ? minutesDeLHeure(vernissage.debut) : null;
  if (vernissage && jourVernissage && minuteDebut !== null) {
    const minuteFin = minutesDeLHeure(vernissage.fin);
    evenements.push({
      id: `${exposition.id}:vernissage`,
      titre: options.titreVernissage(titre),
      jourDebut: jourVernissage,
      jourFin: jourVernissage,
      minuteDebut,
      minuteFin: minuteFin !== null && minuteFin > minuteDebut ? minuteFin : null,
      teinte: 'accent',
      evidence: true,
      href,
    });
  }
  return evenements;
}
